import { CSSProperties } from 'react'
import { css } from '@emotion/react'

interface CursorModProps {
	cursor?: CSSProperties['cursor']
}
export const CursorMods = ({ cursor }: CursorModProps) => css`
	cursor: ${cursor};
`
CursorMods.Pointer = CursorMods({ cursor: 'pointer' })
CursorMods.Default = CursorMods({ cursor: 'default' })
